/*
创建者 魏强(2018.1.25)
banner
*/
<template>
  <div class="focus-warp" :style="style">
    <div class="wrapper">
      <Carousel v-model="value" :autoplay="setting.autoplay" :autoplay-speed="setting.autoplaySpeed"
        :dots="setting.dots" :radius-dot="setting.radiusDot" :trigger="setting.trigger" :arrow="setting.arrow"
        :height="height||496" @on-change="change">
        <CarouselItem v-for="item in data " :key="item.key">
          <router-link class="img-box" :to="item.url" target="_blank">
            <img class="img-item" :src="item.atturl" height="496px" width="100%" />
          </router-link>
        </CarouselItem>
      </Carousel>
    </div>
  </div>
</template>
<script>
export default {
  props: ["data", "height", 'width'],
  data() {
    let data = this.data
    let bgcolor = !!data ? data[0].bgcolor : "#fff";
    return {
      value: 0,
      setting: {
        autoplay: true,
        autoplaySpeed: 2000,
        dots: 'inside',
        radiusDot: true,
        trigger: 'hover',
        arrow: 'never',
      },
      style: { backgroundColor: bgcolor }
    }
  },
  methods: {
    change(oldValue, value) {
      this.style = { backgroundColor: this.data[value].bgcolor }
    }
  }
}

</script>



// WEBPACK FOOTER //
// banner.vue?5bb85d40